<app-auth-inner
  *ngIf="!allMessengersService.isAuth;
    else contentRef
  "></app-auth-inner>
<ng-template #contentRef>
  <div class="layout showEffect">
    <app-leads-navbar></app-leads-navbar>
    <div class="main main-leads w-100 vh-100" [class.chat-media-open]="interfaceService.showTabsInput">
      <app-leads-top-bar></app-leads-top-bar>
      <div>
        <ng-template [ngIf]="!allMessengersService.isAuth" [ngIfElse]="contentRef">
          <app-sign-telegram></app-sign-telegram>
        </ng-template>
        <ng-template #contentRef>
          <!--<app-leads-scan-tasks-table></app-leads-scan-tasks-table>-->
          <app-leads-scan-tasks-list></app-leads-scan-tasks-list>
        </ng-template>
      </div>
    </div>
    <!-- Main Content -->
  </div>
</ng-template>
